import { WritableSignal, signal } from '@angular/core';
import { Company, CompanyTradeTemplate, CompanyUser } from './company.model';

export interface CompanyContextInfo {
  id: string;
  companyName: string;
}

export class CompanyContext {
  readonly company: WritableSignal<Company | undefined> = signal<Company | undefined>(undefined);
  readonly companyName: WritableSignal<string>;
  readonly id: string;
  readonly users: WritableSignal<CompanyUser[]> = signal<CompanyUser[]>([]);
  readonly tradeTemplate = signal<CompanyTradeTemplate | undefined>(undefined);
  readonly isCompanyLeader: WritableSignal<boolean> = signal(false);
  readonly isCompanyUser: WritableSignal<boolean> = signal(false);
  readonly isProjectLeader: WritableSignal<boolean> = signal(false);

  constructor(info: CompanyContextInfo) {
    this.id = info.id;
    this.companyName = signal(info.companyName);
  }

  completeFromCompany(company: Company, currentUserId: string | undefined): void {
    this.company.set(company);
    this.companyName.set(company.Name ?? this.companyName());
    this.users.set(company.Users ?? []);
    this.tradeTemplate.set(company.TradeTemplate);
    const currentUser = currentUserId
      ? this.users().find(user => user.MBEUserId === currentUserId || user.UserId === currentUserId)
      : undefined;
    this.isCompanyLeader.set(currentUser?.IsCompanyLeader === true);
    this.isCompanyUser.set(currentUser !== undefined && !currentUser.IsCompanyLeader);
    this.isProjectLeader.set(currentUser?.IsProjectLeader === true);
  }
}
